/** Fixed values for the sign-in screens. */

export const SUPPORT_EMAIL = 'support@strengthx.com';

/**
 * Store pages for the client screen. Placeholders until the real listings are
 * confirmed (open question for the user).
 */
export const APP_STORE_URL = 'https://apps.apple.com/app/strengthx';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.strengthx';

export const SIGN_IN_PATHS = {
  SIGN_IN: '/sign-in',
  FORGOT: '/forgot-password',
  RESET: '/new-password',
  CODE: '/sign-in/code',
  EXPIRED: '/sign-in/expired',
  PAUSED: '/sign-in/paused',
  TEAM_REMOVED: '/sign-in/team-removed',
  CLIENT: '/sign-in/client',
  SIGNED_OUT: '/sign-in/signed-out',
  WELCOME: '/sign-in/welcome',
  INVITE: '/sign-in/invite',
};

/** The API's answer to a team member's request while their coach is paused. */
export const TEAM_PAUSED_MESSAGE = 'Your team account is paused. Please get in touch with your coach.';

/** Seconds before another code can be asked for (Account/sign-in-settings resendSeconds). */
export const RESEND_SECONDS = 30;

/** localStorage / sessionStorage keys for "Keep me signed in" switched off. */
export const SESSION_ONLY_KEY = 'sx-session-only';
export const SESSION_KEY = 'sx-session';
export const DEVICE_TOKEN_KEY = 'deviceToken';
